// components
import { Typography } from '@centria-ui/components/atoms/typography'

// prime components
import { InputTextarea } from 'primereact/inputtextarea'

// styles
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { InputTextareaProps } from 'primereact/inputtextarea'
import type { FC, Ref } from 'react'

export interface TextAreaProps extends InputTextareaProps {
  label?: string
  variant?: keyof typeof InputsEnum
  inputRef?: Ref<HTMLTextAreaElement>
  color?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const TextArea: FC<TextAreaProps> = ({
  label,
  inputRef,
  rows = 5,
  className = '',
  color = 'light',
  variant = 'block',
  ...props
}) => (
  <div className='w-100'>
    {label && (
      <Typography
        Tag='label'
        className='mb-1'
        fontSize='small'
        htmlFor={props.id}>
        {label}
      </Typography>
    )}
    <InputTextarea
      {...props}
      rows={rows}
      ref={inputRef}
      className={`${className} ${classes.textArea} ${
        classes[`textArea_${variant}`]
      } ${classes[`textArea_${color}`]}`}
    />
  </div>
)
